import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal, MaskLines, SectionLabel } from "./Motion";
import { ETAPES } from "@/lib/content";

const Step = ({ s, i }) => (
  <Reveal>
    <div data-testid={`etape-${i}`} className="relative pb-20 pl-14 sm:pl-24">
      <span className="absolute left-0 top-1 grid h-9 w-9 place-items-center rounded-full border border-[#B39158] bg-[#FAF8F5] font-serif-d text-lg text-[#3D5A4C] sm:left-4">
        {i + 1}
      </span>
      <p className="eyebrow text-[#5b6763]">Étape {String(i + 1).padStart(2, "0")}</p>
      <h3 className="font-serif-d mt-3 text-3xl font-normal leading-tight text-[#1C2826] sm:text-4xl">{s.t}</h3>
      <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#3E4A47] sm:text-[1.05rem]">{s.d}</p>
      <ul className="mt-6 flex flex-wrap gap-2">
        {s.notes.map((n) => (
          <li key={n} className="rounded-full border border-[#3D5A4C]/20 bg-white px-4 py-1.5 text-[0.85rem] text-[#2c3b37]">{n}</li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export const Etapes = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 80, damping: 25 });

  return (
    <section id="indemnisation" data-testid="indemnisation-section" className="bg-[#FAF8F5] py-28 sm:py-36 lg:py-44">
      <div className="mx-auto grid max-w-[1400px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal><SectionLabel index="03">Votre indemnisation</SectionLabel></Reveal>
            <h2 className="font-serif-d mt-8 text-4xl font-light leading-[1.08] text-[#1C2826] sm:text-5xl">
              <MaskLines lines={["Étape", <>par <em className="italic text-[#3D5A4C]">étape</em>.</>]} />
            </h2>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-sm text-base leading-relaxed text-[#3E4A47]">
                Chaque dossier est unique, mais le chemin vers l'indemnisation suit généralement ces grandes étapes.
                Vous savez toujours où en est votre dossier, et pourquoi.
              </p>
              <p className="mt-6 max-w-sm border-l border-[#B39158] pl-4 text-sm leading-relaxed text-[#4A5552]">
                La <strong className="font-semibold text-[#1C2826]">nomenclature Dintilhac</strong> recense une vingtaine de postes de préjudices, patrimoniaux et extrapatrimoniaux,
                temporaires et permanents, pour la victime directe comme pour ses proches.
              </p>
            </Reveal>
          </div>
        </div>
        <div ref={ref} className="relative lg:col-span-7 lg:col-start-6">
          <div className="absolute bottom-0 left-[17px] top-2 w-px bg-[#3D5A4C]/15 sm:left-[33px]" />
          <motion.div style={{ scaleY }} className="absolute bottom-0 left-[17px] top-2 w-px origin-top bg-[#B39158] sm:left-[33px]" />
          {ETAPES.map((s, i) => <Step key={s.t} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
